/*------------------------------------*\
    MODULES
\*------------------------------------*/
import Shepherd from 'shepherd.js';

var site = require('../../site/_data/site');
var translate = require('../../site/_data/i18n');

// Get locale from URL
var pathArray = window.location.pathname.split('/');
var locale = pathArray[1];

/*------------------------------------*\
    FEEDBACK TOUR REVIEW
\*------------------------------------*/
class FeedbackTourReview {
    constructor(passedElement) {
        let self = this;
        self.elem = passedElement;
    }

    /*-------------------------------------------------*\
        INIT
    \*-------------------------------------------------*/
    init() {
        let self = this;

        var shepherd = new Shepherd.Tour({
          defaultStepOptions: {
            classes: 'tour-review',
            scrollTo: {
              behavior: 'smooth',
              block: 'center'
            }
          },
          steps: [
            {
              title: translate.feedback.reviewYourFeedback.title[locale],
              text: translate.feedback.reviewYourFeedback.description[locale],
              buttons: [
                {
                  action: function() {
                    return this.next();
                  },
                  text: translate.feedback.reviewYourFeedback.close[locale]
                }
              ]
            }
          ],
          useModalOverlay: true
        });

        // If consultation closed don't show
        if(site.consultation.feedback_active == true) {
          shepherd.start();
        }
    }
}

export default FeedbackTourReview;